/**
 * @generated SignedSource<<202005002f6c6ac585854a3467c742b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminDiscussionCardPaginationFragment_adminDashboardFlowComments$data = {
  readonly adminDashboardFlowComments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly comment: {
          readonly commentText: string;
          readonly createdAt: Date | null | undefined;
          readonly gwtUser: {
            readonly fullName: string;
            readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_gwtUser">;
          } | null | undefined;
          readonly rowId: UUID;
          readonly unread: boolean;
        } | null | undefined;
        readonly flow: {
          readonly name: string;
          readonly rowId: UUID;
          readonly " $fragmentSpreads": FragmentRefs<"FlowLink_flow">;
        } | null | undefined;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "AdminDiscussionCardPaginationFragment_adminDashboardFlowComments";
};
export type AdminDiscussionCardPaginationFragment_adminDashboardFlowComments$key = {
  readonly " $data"?: AdminDiscussionCardPaginationFragment_adminDashboardFlowComments$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminDiscussionCardPaginationFragment_adminDashboardFlowComments">;
};

import AdminDiscussionCardFlowCommentsPaginationQuery_graphql from './AdminDiscussionCardFlowCommentsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "adminDashboardFlowComments"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": AdminDiscussionCardFlowCommentsPaginationQuery_graphql
    }
  },
  "name": "AdminDiscussionCardPaginationFragment_adminDashboardFlowComments",
  "selections": [
    {
      "alias": "adminDashboardFlowComments",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "UNREAD_COMMENTS_CREATED_AT_DESC"
        }
      ],
      "concreteType": "AdminDashboardFlowCommentsConnection",
      "kind": "LinkedField",
      "name": "__AdminDiscussionCardPaginationFragment_adminDashboardFlowComments_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AdminDashboardFlowCommentsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AdminDashboardFlowComment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Comment",
                  "kind": "LinkedField",
                  "name": "comment",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "unread",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "commentText",
                      "storageKey": null
                    },
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GwtUser",
                      "kind": "LinkedField",
                      "name": "gwtUser",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fullName",
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "UserAvatar_gwtUser"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Flow",
                  "kind": "LinkedField",
                  "name": "flow",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "FlowLink_flow"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__AdminDiscussionCardPaginationFragment_adminDashboardFlowComments_connection(orderBy:\"UNREAD_COMMENTS_CREATED_AT_DESC\")"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "3cce62313d54040a0cc9a9fd4fe77299";

export default node;
